import React, { useState } from 'react';
import DocumentAnnotator from './DocumentAnnotator';

const AnnotationDemo = () => {
  // Sample OCR data (you would replace this with your actual OCR data)
  const sampleOcrData = {
    "image": {
      "width": 717,
      "height": 823
    },
    "predictions": [
      {
        "width": 315,
        "height": 189,
        "x": 180.5,
        "y": 128.5,
        "confidence": 0.9756296,
        "class_id": 0,
        "class": "GEETA LIME DEPOT ( F.Y.2024-25 ) 2ND PLOT NO 45/51 PUNAR JIVAN BUILDING KAMATHIPURA 5TH LANE KAMATHIPURA MUMBAI - 400008 MAHARASHTRA GST NO . 27AGAPJ0224F1Z2 GSTIN / UIN : 27AGAPJ0224F1Z2 State Name Maharashtra , Code : 27 E - Mail geetalimedepot9892@gmail.com Buyer ( Bill to ) Unitedone Infra PVT . LTD . D - 221 , Neelkanth business Park , Vidyavihar ( w ) , Mumbai",
        "detection_id": "e6d3f16a-f853-4e1c-b1c3-1d9a12d463f8",
        "parent_id": "image"
      },
      {
        "width": 121,
        "height": 73,
        "x": 413.5,
        "y": 64.5,
        "confidence": 0.9688084,
        "class_id": 1,
        "class": "Invoice No. GLD / 2024-25 / 0258 Delivery Note 101 , 102 , 103",
        "detection_id": "3b54274c-5443-4b76-af89-5beb1ae28173",
        "parent_id": "image"
      },
      {
        "width": 68,
        "height": 34,
        "x": 545,
        "y": 40,
        "confidence": 0.9889672,
        "class_id": 2,
        "class": "Dated 28 - Mar - 25",
        "detection_id": "abc62805-9000-46f6-9e3c-61ceb174ab72",
        "parent_id": "image"
      },
      {
        "width": 64,
        "height": 13,
        "x": 639,
        "y": 419.5,
        "confidence": 0.98522246,
        "class_id": 33,
        "class": "71,500.00",
        "detection_id": "2276d37d-5442-4883-8e2c-d756b33ec253",
        "parent_id": "image"
      },
      {
        "width": 81,
        "height": 31,
        "x": 636.5,
        "y": 678.5,
        "confidence": 0.9685646,
        "class_id": 56,
        "class": "93,975.00 E. & O.E",
        "detection_id": "7a9d4d35-afd9-4825-88f6-beb120fe1051",
        "parent_id": "image"
      }
    ]
  };

  const [annotations, setAnnotations] = useState({});
  const [imageUrl, setImageUrl] = useState('');
  const [ocrData, setOcrData] = useState(sampleOcrData);
  const [jsonInput, setJsonInput] = useState(JSON.stringify(sampleOcrData, null, 2));

  const handleAnnotationSave = (newAnnotations) => {
    setAnnotations(newAnnotations);
    console.log('Annotations saved:', newAnnotations);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setImageUrl(url);
    }
  };

  const handleJsonUpdate = () => {
    try {
      const parsedData = JSON.parse(jsonInput);
      setOcrData(parsedData);
    } catch (error) {
      alert('Invalid JSON format. Please check your input.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Document Annotation Tool
          </h1>
          <p className="text-gray-600 mb-6">
            Upload an image and provide OCR data to start annotating document regions with labels.
          </p>
          
          {/* Controls */}
          <div className="bg-white rounded-lg shadow p-6 mb-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Image Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Upload Document Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
                {imageUrl && (
                  <p className="text-sm text-green-600 mt-2">✓ Image loaded successfully</p>
                )}
              </div>

              {/* JSON Data Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  OCR JSON Data
                </label>
                <div className="flex gap-2">
                  <textarea
                    value={jsonInput}
                    onChange={(e) => setJsonInput(e.target.value)}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono text-sm"
                    rows="4"
                    placeholder="Paste your OCR JSON data here..."
                  />
                  <button
                    onClick={handleJsonUpdate}
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors h-fit"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Usage Instructions */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-blue-800 mb-2">How to use:</h3>
            <ol className="list-decimal list-inside text-sm text-blue-700 space-y-1">
              <li>Upload a document image (JPG, PNG, etc.)</li>
              <li>Ensure your OCR JSON data contains predictions with coordinates and text</li>
              <li>Click on any blue-highlighted region in the document</li>
              <li>Assign a label (company_name, invoice_no, etc.) to that region</li>
              <li>View the annotated results and copy the JSON output</li>
            </ol>
          </div>
        </div>

        {/* Annotation Component */}
        {imageUrl ? (
          <DocumentAnnotator
            imageUrl={imageUrl}
            ocrData={ocrData}
            onAnnotationSave={handleAnnotationSave}
            initialAnnotations={annotations}
          />
        ) : (
          <div className="bg-white rounded-lg shadow-lg p-12 text-center">
            <div className="text-gray-400 mb-4">
              <svg className="mx-auto h-16 w-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No Image Uploaded</h3>
            <p className="text-gray-500">Please upload a document image to start annotating.</p>
          </div>
        )}

        {/* Current Annotations Display */}
        {Object.keys(annotations).length > 0 && (
          <div className="mt-8 bg-white rounded-lg shadow p-6">
            <h3 className="text-lg font-semibold mb-4">Current Annotations</h3>
            <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
              {JSON.stringify(annotations, null, 2)}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnnotationDemo; 